module.exports = __webpack_public_path__ + "static/img/master_studio_member_2.d38a449.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_member_2.png
// module id = PE7Q
// module chunks = 11